import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, TREATMENTS } from "./data";

const inputCls =
  "w-full bg-transparent border-b border-[#E5DDD0] focus:border-clay outline-none py-3 text-sm text-ink placeholder:text-ink/35 transition-colors duration-300";

export default function EnquiryForm({ initialTreatment = "", idPrefix = "enquiry", onSuccess }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    treatment: initialTreatment,
    message: "",
  });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      toast.success("Enquiry sent — we'll be in touch within 24 hours.");
      setForm({ name: "", email: "", phone: "", treatment: initialTreatment, message: "" });
      onSuccess?.();
    } catch (err) {
      toast.error("Something went wrong. Please try again, or call us directly.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form data-testid={`${idPrefix}-form`} onSubmit={submit} className="space-y-6">
      <div className="grid sm:grid-cols-2 gap-6">
        <div>
          <label htmlFor={`${idPrefix}-name`} className="text-xs uppercase tracking-[0.2em] text-ink/50 font-semibold">
            Full name *
          </label>
          <input
            id={`${idPrefix}-name`}
            data-testid={`${idPrefix}-input-name`}
            required
            value={form.name}
            onChange={set("name")}
            placeholder="Your name"
            className={inputCls}
          />
        </div>
        <div>
          <label htmlFor={`${idPrefix}-email`} className="text-xs uppercase tracking-[0.2em] text-ink/50 font-semibold">
            Email *
          </label>
          <input
            id={`${idPrefix}-email`}
            data-testid={`${idPrefix}-input-email`}
            type="email"
            required
            value={form.email}
            onChange={set("email")}
            placeholder="you@email.com"
            className={inputCls}
          />
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-6">
        <div>
          <label htmlFor={`${idPrefix}-phone`} className="text-xs uppercase tracking-[0.2em] text-ink/50 font-semibold">
            Phone
          </label>
          <input
            id={`${idPrefix}-phone`}
            data-testid={`${idPrefix}-input-phone`}
            type="tel"
            value={form.phone}
            onChange={set("phone")}
            placeholder="Optional"
            className={inputCls}
          />
        </div>
        <div>
          <label htmlFor={`${idPrefix}-treatment`} className="text-xs uppercase tracking-[0.2em] text-ink/50 font-semibold">
            Treatment interest
          </label>
          <select
            id={`${idPrefix}-treatment`}
            data-testid={`${idPrefix}-select-treatment`}
            value={form.treatment}
            onChange={set("treatment")}
            className={`${inputCls} cursor-pointer`}
          >
            <option value="">Not sure yet — advise me</option>
            {TREATMENTS.map((t) => (
              <option key={t.id} value={t.name}>
                {t.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div>
        <label htmlFor={`${idPrefix}-message`} className="text-xs uppercase tracking-[0.2em] text-ink/50 font-semibold">
          Message
        </label>
        <textarea
          id={`${idPrefix}-message`}
          data-testid={`${idPrefix}-textarea-message`}
          rows={4}
          value={form.message}
          onChange={set("message")}
          placeholder="Tell us about your skin goals…"
          className={`${inputCls} resize-none`}
        />
      </div>

      <button
        data-testid={`${idPrefix}-submit-button`}
        type="submit"
        disabled={sending}
        className="w-full sm:w-auto rounded-full bg-ink text-cream text-sm font-semibold px-10 py-4 hover:bg-clay hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-60 disabled:hover:translate-y-0"
      >
        {sending ? "Sending…" : "Send enquiry"}
      </button>
    </form>
  );
}
